module.exports = __webpack_public_path__ + "static/media/map-marker-icon.e81d0575.svg";